import { flsModules } from "../files/modules.js";

import Swiper from "swiper";
import { Thumbs, Navigation, Grid} from "swiper/modules";

import { Fancybox } from "@fancyapps/ui";

document.addEventListener("DOMContentLoaded", () => {
  const forSlider = document.querySelector(".reviews__slider");
  if (!forSlider) return;

  new Swiper(".reviews__slider", {
    modules: [Navigation],

    loop: true,
    centeredSlides: true,
    spaceBetween: 24,
    speed: 600,

    navigation: {
      nextEl: ".rev-next",
      prevEl: ".rev-prev",
    },

    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 16,
        centeredSlides: false,
      },
      500: {
        slidesPerView: 2,
        centeredSlides: false,
      },
      1024: {
        slidesPerView: 3,
        centeredSlides: true,
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const sliderEl = document.querySelector(".team__slider");
  if (!sliderEl) return;

  const swiper = new Swiper(".team__slider", {
    modules: [Navigation],
    loop: true,
    centeredSlides: true,
    watchSlidesProgress: true,
    speed: 700,
    // slidesPerView: 5,
    // spaceBetween: 1,

    navigation: {
      nextEl: ".team-next",
      prevEl: ".team-prev",
    },

    breakpoints: {
      0: {
        slidesPerView: 1.5,
        spaceBetween: 0,
      },
      500: {
        slidesPerView: 1.6,
        spaceBetween: 2,
      },
      768: {
        slidesPerView: 2.2,
        spaceBetween: 4,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 4,
      },
      1400: {
        slidesPerView: 4.2,
        spaceBetween: 4,
      },
      1600: {
        slidesPerView: 5,
        spaceBetween: 4,
      }
    },

    on: {
      init(swiper) {
        requestAnimationFrame(() => updateTeamSlider(swiper));
      },
      progress(swiper) {
        updateTeamSlider(swiper);
      },
      setTransition(swiper, duration) {
        swiper.slides.forEach((slide) => {
          const card = slide.querySelector(".team__card");
          if (card) {
            card.style.transitionDuration = `${duration}ms`;
          }
        });
      },
      resize(swiper) {
        updateTeamSlider(swiper);
      }
    }
  });

  function updateTeamSlider(swiper) {
    swiper.slides.forEach((slide) => {
      const card = slide.querySelector(".team__card");
      if (!card) return;

      const progress = slide.progress;
      const abs = Math.abs(progress);

      // обмежуємо, щоб далекі loop-дублікати не псували картинку
      const p = Math.min(abs, 2);

      // більш м'яка дуга
      const rotate = progress * -6; // було сильніше
      const translateY = p * 24 + p * p * 6; // плавніша дуга
      const translateX = progress * -4; // майже не розсовує
      const scale = 1 - p * 0.025; // менша різниця між центром і сусідами
      const opacity = 1 - p * 0.4;

      card.style.transform = `
        translate3d(${translateX}px, ${translateY}px, 0)
        rotate(${rotate}deg)
        scale(${scale})
      `;

      card.style.opacity = opacity;
      card.style.zIndex = `${1000 - Math.round(abs * 10)}`;
      card.style.filter = "none";
    });
  }
});

Fancybox.bind("[data-fancybox]", {
  type: "inline",
  dragToClose: false
});